export const ContactPoint = {
    Headquarters: "Headquarters",
    IBE: "IBE",
    OnlineCheck: "OnlineCheck",
    Magazine: "Magazine",
    LostAndFound: "LF"
}